// extracted by mini-css-extract-plugin
export default {"field":"_10eCvbkAjlb9WI65aoLPrC","tab":"_3ELexEEvBmxaFTZRFALoG7","favicon":"kulzVnPxbbZ4EfqJCMn6f","input":"_35_8oDU4EVaxdcx6hFOick","message":"Vruy_4S_CEAVoNA5eq4ty"};